<template>
	<v-app-bar :clipped-left="$vuetify.breakpoint.mdAndUp" app class="primary" dark fixed dense v-if="!getLicenseExpired">
		<v-toolbar-title style="width: 300px">
			<v-app-bar-nav-icon @click="toggleDrawer" />
			<span class="hidden-sm-and-down">{{ getName }}</span>
		</v-toolbar-title>
		<v-spacer />
		<template v-if="getId === '5fde132ca9cc36749c65b7c4'">
			<img alt="Progetto finanziato Unione Europea" src="@/assets/finanziato_unione_europea.png" style="width: auto; height: 35px;"/>
		</template>

		<template v-if="getRole === 2">
			<v-btn depressed icon rounded @click="goToMessages()" :title="$vuetify.lang.t('$vuetify.front.messages.all')">
				<v-badge :content="getMyMessages.messages_unread" :value="getMyMessages.messages_unread" color="red" overlap>
					<v-icon> mdi-email-outline </v-icon>
				</v-badge>
			</v-btn>
			<v-btn depressed icon rounded @click="goToDocuments()" :title="$vuetify.lang.t('$vuetify.front.documents.all')">
				<v-badge :content="getMyUnreadDocuments" :value="getMyUnreadDocuments" color="red" overlap>
					<v-icon> mdi-file-document-multiple-outline </v-icon>
				</v-badge>
			</v-btn>
		</template>
		<notifications-menu />
		<v-btn icon large to="/">
			<v-avatar size="32px" tile>
				<img alt="Az Seller" src="@/assets/logo.svg" />
			</v-avatar>
		</v-btn>
	</v-app-bar>

</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import NotificationsMenu from './NotificationsMenu.vue';

export default {
	name: 'Toolbar',
	components: { NotificationsMenu },
	data() {
		return {
			selected: [],
			benched: 0,
			menu_messages: '',
		};
	},
	async mounted() {
		if (this.getRole === 2) {
			this.fetchMyMessages();
			this.fetchMyUnreadDocuments();
		}
	},
	methods: {
		...mapMutations({
			setDrawer: 'settings/setDrawer',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchMyMessages: 'messages/fetchMyMessages',
			fetchMyUnreadDocuments: 'documents/fetchMyUnreadDocuments',
			//'resetMessages' : 'settings/resetMessages'
		}),
		toggleDrawer() {
			this.setDrawer(!this.getDrawer);
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
		},
		goToMessages() {
			this.$router.push('/messages');
		},
		goToDocuments() {
			this.$router.push('/documents');
		},
	},
	computed: {
		...mapGetters({
			getDrawer: 'settings/getDrawer',
			getDrawerFilter: 'settings/getDrawerFilter',
			getName: 'settings/getName',
			getRole: 'profile/getRole',
			getLicenseExpired: 'profile/getLicenseExpired',
			getId: 'profile/getId',
			getMyMessages: 'messages/getMyMessages',
			getMyUnreadDocuments: 'documents/getMyUnreadDocuments',
		}),
	},
};
</script>

<style scoped></style>
